import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

export const useCanCreateDiscussion = () => {
  const { currentUser } = useDefaultAppContexts();
  const { topicId } = useTopicContext();

  if (!currentUser) {
    return false;
  }

  const {
    can_create_forum_post: canCreateForumPost,
    can_access_forum: canAccessForum,
  } = currentUser;
  const isGroupForum = !!topicId;

  return (canAccessForum && canCreateForumPost) || isGroupForum;
};
